const PUBLIC_API_URL = '/api/public-cemetery';
const API_URL = '/api/cemetery';
function grabFormAsObject(jqueryForm) {
    var data = jqueryForm.serializeArray();
    var obj = {};

    data.forEach(function(item) {
        if (typeof obj[item.name] === 'undefined') {
            obj[item.name] = item.value;
        } else {
            obj[item.name] += ';' + item.value;
        }
    });

    return obj;
}

if (Cookies.get('logged_in')) {
    window.api = API_URL;
} else {
    window.api = PUBLIC_API_URL;
}

// if (location.hostname === 'temeto.envimap.hu') {
//     window.baseAjaxUrl = 'https://temeto.envimap.hu';
// } else if (location.hostname === 'localhost' || location.hostname === 'temeto-teszt.envimap.hu') {
//     window.baseAjaxUrl = 'https://temeto-teszt.envimap.hu';
// }

//Delete old cookies once
function deleteOldCookies() {
    if (Cookies.get('deleted_old_token')) {
        return;
    }
    Cookies.set('deleted_old_token', true);
    Cookies.remove('operator_token');
}

const DONEGDPRParams = {
    color: '#d99d26',
    lang: 'hu',
    text_url: false,
    policy_url: 'https://envirosense.hu/wp-content/uploads/2021/05/Adatkezelesi_tajekoztato.pdf',
    cookie_bar_headline: '',
    disable_close_button: true,
    groups: {
        always_active: [
            {
                name:
                    'temeto.envimap.hu saj\u00e1t s\u00fctijei (DONEGDPRConsent, DONEGDPRAlertBoxClosed)',
            },
        ],
        performance: [{ name: '_ga' }, { name: '_ga_CEK123SXC3' }],
    },
    functionalCallback: function() {},
    performanceCallback: function() {},
    targetingCallback: function() {},
};

const breakpoints = [
    { width: 1900, cols: 6 },
    { width: 1700, cols: 5 },
    { width: 1500, cols: 4 },
    { width: 1225, cols: 3 },
    { width: 981, cols: 2 },
    { width: 620, cols: 3 },
    { width: 520, cols: 2 },
    { width: 0, cols: 1 },
];

function resetSuggestionButtons() {
    $('#about-box-footer--button').removeClass('visible-print');
    $('#about-box-footer--cancel').addClass('visible-print');
}

function resetFeedbackModalFields() {
    $('#feedback-modal--email').val('');
    $('#feedback-modal--textarea').val('');
    $('.feedback-modal--error-text').html('');
}

/**
 * Format a date to YYYY-MM-DD format
 * @param {Date|string} date the date to format
 * @returns {string} The new date in YYYY-MM-DD format
 */
const formatDate = date => {
    const d = new Date(date);
    const month = d.getMonth() < 9 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
    const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
    return `${d.getFullYear()}-${month}-${day}`;
};

//Detect device size for urn walls column
function getUrnwallCollsByWindowWidth() {
    let colsToGet = 1;
    const windowWidth = window.innerWidth;

    for (const breakpoint of breakpoints) {
        if (windowWidth > breakpoint.width) {
            colsToGet = breakpoint.cols;
            break;
        }
    }

    return colsToGet;
}

function createThumbnailAndSlider(photos, displayCountElement, slider, sliderOpenerElement) {
    const countedPhotos = photos.length;
    displayCountElement.text(countedPhotos);

    photos.sort((a, b) => new Date(b.photoTakenDate) - new Date(a.photoTakenDate));

    const thumbnail = photos[0].photoPath.includes('photos/')
        ? photos[0].photoPath.replace(/photos\//g, 'photos_preview/')
        : `photos_preview/${photos[0].photoPath}`;
    $('.about-box .img-container').css('background-image', `url(content/${thumbnail})`);

    let sliderContent = ``;

    photos.map(function(photo) {
        const photoPath = photo.photoPath.includes('photos/')
            ? photo.photoPath.replace(/photos\//g, 'photos_normal/')
            : `photos_normal/${photo.photoPath}`;
        const photoTakenDate = photo.photoTakenDate;

        sliderContent += `<div>
                <a href="content/${photoPath}" class="js-slider-url" target="_blank">
                    <img src="content/${photoPath}" alt="" class="js-slider-image slider-image">
                </a>
                <p class="swiper-date">
                    Fénykép készítésének dátuma:
                    <br>
                    <span class="js-date">${photoTakenDate || '-'}</span>
                </p>
            </div>`;
    });

    slider
        .slick('unslick')
        .html(sliderContent)
        .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            variableWidth: false,
            autoplay: false,
            prevArrow: $('.js-previous-slide'),
            nextArrow: $('.js-next-slide'),
        });

    sliderOpenerElement.removeClass('visible-print');
}

function goToUrnwallActiveSlide(slider) {
    setTimeout(() => {
        slider.slick('setPosition');

        let activeSlide = slider
            .find('.urn--active')
            .closest('.slick-slide')
            .attr('data-slick-index');

        activeSlide = parseInt(activeSlide);

        slider.slick('slickGoTo', activeSlide);
    }, 500);
}

function createDeceasedList(deceased, showFuneralAndValidTime = true) {
    return deceased.map(d => {
        let link = '';
        let desc = '';
        const birthDate = d.birthDate ? d.birthDate.split('-')[0] : 'n.a.';
        const deathDate = d.deathDate ? d.deathDate.split('-')[0] : 'n.a.';
        const funeralTime = d.funeralTime ? `Temetés dátuma: ${formatDate(d.funeralTime)}` : '';
        const graveValidUntil = d.graveValidUntil
            ? `Sírhely lejár: ${formatDate(d.graveValidUntil)}`
            : '';

        if (d.link !== null) {
            link = `<div><a class="funeral-time" target="_blank" href="${d.link.url}">${d.link.text}</a></div>`;
        }

        if (d.description !== null) {
            desc = `<p class="funeral-time">${d.description}</p>`;
        }

        return `<div class="search-bar-results-block" data-id="${d.id}">
                    <div class="search-bar-result js-zoom-to d-flex">
                        <div class="d-flex">
                            <img src="assets/img/cross.svg" alt="">
                            <div>
                                <p class="search-bar-graveyard js-find-name">${d.name}</p>
                                <p class="time js-find-date">${birthDate} - ${deathDate}</p>
                                ${
                                    showFuneralAndValidTime
                                        ? `
                                    <p class="js-funeral-time funeral-time">${funeralTime}</p>
                                    <p class="js-grave-valid funeral-time">${graveValidUntil}</p>
                                    `
                                        : ''
                                }
                                ${link} ${desc}
                            </div>
                        </div>
                        <img class="edit-icon js-open-feedback" style="display: none;" src="assets/img/icons/pencil.svg" data-id="${
                            d.id
                        }">
                    </div>
                </div>`;
    });
}

function setFeedbackButtonStatus(urns, deads, urnwall, feedbackButton, cancelButton) {
    if (urns.length !== 0) {
        let hasActive = false;
        urnwall.each(function() {
            if ($(this).find('.urn--active').length > 0) {
                hasActive = true;
            }
        });
        if (!hasActive) {
            feedbackButton.addClass('visible-print');
            cancelButton.addClass('visible-print');
        }
    } else if (urns.length === 0 && deads?.length === 0) {
        feedbackButton.addClass('visible-print');
        cancelButton.addClass('visible-print');
    } else {
        resetSuggestionButtons();
    }
}

function createUrnwallSlider(urns, colsToGet, urnwallSlider) {
    const sortedUrns = [...urns].sort((a, b) => a.x - b.x || a.y - b.y);
    let output = `<div class="urn-slide"><table class="js-urnwall-table"><tr>`;
    let colsHave = 0;
    let previousX;

    for (let i = 0; i < sortedUrns.length; i++) {
        const { deads, id: graveId, x: currentX } = sortedUrns[i];

        if (!deads) {
            continue;
        }

        if (previousX && previousX !== currentX) {
            output += `</tr><tr>`;
            colsHave++;
        }

        if (colsHave === colsToGet) {
            output += `</tr></table></div><div class="urn-slide"><table class="js-urnwall-table"><tr>`;
            colsHave = 0;
        }

        output += `
            <td class="js-load-one-urnwall-data" data-id="${graveId}">
                <p>
                    ${deads.map(d => d.name).join(`<br>`)}
                </p>
            </td>`;

        previousX = currentX;
    }

    output += `</tr></table></div>`;
    $('.js-get-graveyard').removeClass('information-tab-visible');

    //Reinit slider with the new output
    $('.urn-slide').remove();
    urnwallSlider
        .slick('unslick')
        .html(output)
        .slick({
            autoplay: false,
            infinite: false,
            variableWidth: false,
            prevArrow: $('.js-urnwall-left-arrow'),
            nextArrow: $('.js-urnwall-right-arrow'),
            slidesToShow: 1,
        });
}
